import React, { ReactNode, useRef } from 'react';
import { Button, Col, ButtonGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';

/**
 * Help button
 */
export default function HelpButton({
  currentActiveKey,
  setActiveKey,
  text,
  children,
  activeKey,
}: {
  currentActiveKey: string;
  setActiveKey: (activeKey?: string) => void;
  text: string;
  children: ReactNode;
  activeKey: string;
}) {
  const isActive = currentActiveKey === activeKey;
  const otherButtonIsActive = currentActiveKey && !isActive;

  const buttonRef = useRef<HTMLDivElement>();

  if (otherButtonIsActive) return null;

  return (
    <>
      <Col xs={12} className="my-1">
        <ButtonGroup className="d-flex flex-row h-100" ref={buttonRef}>
          <Button
            className="w-100 h-100 flex-grow-1"
            onClick={() => {
              setActiveKey(activeKey);
              setTimeout(
                () =>
                  buttonRef?.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                  }),
                20,
              );
            }}
            variant={isActive ? 'outline-primary' : 'primary'}
            disabled={isActive}
          >
            {text}
          </Button>

          {isActive && (
            <Button
              variant="primary"
              onClick={() => setActiveKey()}
              className="px-3"
            >
              <FontAwesomeIcon icon={faClose} />
            </Button>
          )}
        </ButtonGroup>
      </Col>

      {isActive && (
        <Col xs={12} className="my-3">
          {children}
        </Col>
      )}
    </>
  );
}
